import React, { ReactElement } from 'react'
import { useLocation } from 'react-router-dom'
import Checkout, { allTravelRuleFieldsCollected } from '../components/Checkout'
import LoadingCheckout from './LoadingCheckout'
import { parsePreviewHash } from '../util/Preview'
import { previewPaymentLink } from '../util/PreviewData'

function PaymentLinkPreview(): ReactElement {
  const location = useLocation()
  const paymentLinkData = parsePreviewHash<any>(location.hash) ?? previewPaymentLink

  if (!paymentLinkData.products || paymentLinkData.products.length <= 0) {
    if (!paymentLinkData.customizations?.allowFreeInputAmount) { return <LoadingCheckout /> }
  }

  return <Checkout
    checkoutData={{
      ...paymentLinkData,
      products: paymentLinkData.products.map(p => {
        return {
          product: p,
          quantity: 1
        }
      })
    }}
    onCheckout={() => { } }
    isPreProcessingPayment={false}
    isSuccess={false}
    successElement={<></>}
    hideTravelRuleFields
    travelRuleFieldsCollected={allTravelRuleFieldsCollected()}
  />
}

export default PaymentLinkPreview
